<template>
  <el-submenu
    v-if="Array.isArray(menu.children) && menu.children.length > 0"
    :key="menu.index"
    :index="menu.index"
  >
    <div slot="title">
      {{ menu.name }}
    </div>
    <sub-menu
      v-for="item in menu.children"
      :key="item.index"
      :menu="item"
    />
  </el-submenu>
  <el-menu-item
    v-else-if="!isUrl(menu.path)"
    :index="menu.index"
    :route="{path: menu.path}"
  >
    <div
      slot="title"
      class="menu-link"
    >
      {{ menu.name }}
    </div>
  </el-menu-item>
  <a
    v-else
    style="color: init"
    target="_blank"
    class="external-link-item"
    :href="getUrl(menu.path)"
  >{{ menu.name }}</a>
</template>

<script>
import utils from '~/utils/index';
export default {
  name: 'SubMenu',
  props: {
    menu: {
      type: Object,
      required: true,
    }
  },
  mounted() {
    console.log(this.menu);
  },
  methods: {
    isUrl(link) {
      return utils.isExternalLink(link);
    },
    getUrl(link) {
      return link.match(/((http|ftp|https):\/\/)?(([a-zA-Z0-9._-]+\.[a-zA-Z]{2,6})|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,4})*(\/[a-zA-Z0-9&%_./-~-]*)?/)[0];
    }
  }
};
</script>
<style lang="less" scoped>
  .external-link-item {
    display: block;
    font-size: 14px;
    color: #303133;
    /* padding: 0 30px; */
    cursor: pointer;
    transition: border-color .3s,background-color .3s,color .3s;
    box-sizing: border-box;
    height: 44px;
    line-height: 44px;
    position: relative;
    -webkit-box-sizing: border-box;
    white-space: nowrap;
    list-style: none;
    &:hover {
      outline: 0;
      background-color: #ecf5ff;
    }
  }
  .demo-siderbar-menu{
    a{
      padding-left: 20px;
    }
    .el-menu--inline{
      a{
        padding-left: 40px;
      }
      .el-submenu{
        a{
          padding-left: 60px;
        }
      }
    }
  }
</style>
